import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { listarCatalogoPermisos } from "../services/permisos-service";

/** Catálogo COMPLETO de permisos (incluye inactivos) · para el gestor. */
export const catalogoPermisosQueryOptions = queryOptions({
  queryKey: qk.adminPermisosGestion,
  queryFn: listarCatalogoPermisos,
});

export function useCatalogoPermisos() {
  return useSuspenseQuery(catalogoPermisosQueryOptions);
}
